import { createContext } from "react";

const ThemeContext = createContext({
  theme: "dark",
});

export default ThemeContext;
